import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { X } from "react-feather";
import { NavLink } from "react-router-dom";
import LastLocation from "../LastLocation";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SrlLastLocation from "../../srl/components/SrlLastLocation";
import useSrlHelper from "../../hooks/useSrlHelper";

const thingsArr = {
  asset: "assets",
  person: "people",
  zone: "zones",
  assets: "assets",
  people: "people",
  zones: "zones",
};

/** @callback clickTargetCallback @param {boolean} show */

/**
 * InfoWindow properties
 * @typedef {object} InfoWindowProps
//  * @property {ReactNode} children Rendered when you have access
 * @property {object} show
 * @property {object} anchorPos - location
 * @property {clickTargetCallback} clickTarget - callback when clicked
 * @property {React.MouseEvent<SVGElement>} onClose
 */

/** Info Window
 * @param {InfoWindowProps} props
 * @returns {JSX.Element | null}
 */
const InfoWindow = (props) => {
  const [zIndex, setZIndex] = useState(10000000);
  const { isSrl, itemDisplayName } = useSrlHelper();

  // const t1 = props.hasPower;

  useEffect(() => {
    if (props.show.active) {
      setZIndex(10000001);
    } else {
      setZIndex(10000000);
    }
  }, [props.show.active]);

  /** The Default Style - @type {React.CSSProperties} - the style */
  const infoWindowStyle = {
    position: "absolute", // 👈 fixed to viewport, not a parent
    bottom: "unset", // 👈 remove old bottom anchor
    top: props.anchorPos.top, // 👈 use measured position
    left: props.anchorPos.left,
    transform: "translate(-50%, -100%)", // 👈 shift up & centre horizontally
    minWidth: 240,
    boxShadow: "0 2px 7px 1px rgba(0, 0, 0, 0.3)",
    fontSize: 13,
    zIndex: zIndex,
    flexWrap: "nowrap",
    borderRadius: "8px",
    cursor: "default",
  };

  return !props.show.hide ? (
    <div
      style={infoWindowStyle}
      className="bg-white marker-label"
      onClick={(e) => {
        e.stopPropagation();
        props.clickTarget(props.show);
      }}
    >
      <Card className="m-0">
        <Card.Body className="pb-0 pt-1 pe-1 ps-2">
          <X
            className="float-end cursor-pointer"
            size={18}
            onClick={(e) => props.onClose(e)}
          />
          <h5 className="mt-2 mb-0">
            <NavLink
              to={{
                pathname: `/${thingsArr[props.show.type]}/edit`,
                search: `?id=${props.show.id}`,
              }}
            >
              {/* {itemDisplayName(props.show.lastPosition)} */}
              {isSrl() ? (
                <>{itemDisplayName(props.show)}</>
              ) : (
                <>
                  {props.show.compoundName}{" "}
                  {props.show.reference ? `(${props.show.reference})` : ""}
                </>
              )}
            </NavLink>
          </h5>
        </Card.Body>
      </Card>
      <div className="ps-2 pe-2">
        {isSrl() ? (
          <>
            {props.show && (
              <Card className="mb-0 border-top">
                <Card.Body className={"p-0"}>
                  <div
                    data-toggle="tooltip"
                    title=""
                    data-placement="right"
                    className="text-nowrap"
                  >
                    <FontAwesomeIcon
                      icon={faLink}
                      fixedWidth
                      className="me-1"
                    />{" "}
                    SRL Fleet #: <b>{props.show.fleetNumber}</b>
                  </div>
                  <div
                    data-toggle="tooltip"
                    title=""
                    data-placement="right"
                    className="text-nowrap"
                  >
                    <FontAwesomeIcon
                      icon={faLink}
                      fixedWidth
                      className="me-1"
                    />{" "}
                    Customer Fleet #: <b>{props.show.suppString2}</b>
                  </div>
                </Card.Body>
              </Card>
            )}
          </>
        ) : (
          <></>
        )}
        {isSrl() ? (
          <SrlLastLocation profile={props.show} markerLabel detail />
        ) : (
          <LastLocation profile={props.show} markerLabel detail />
        )}
      </div>
    </div>
  ) : null;
};

export default InfoWindow;
